import classNames from 'classnames'
import PropTypes from 'prop-types'
import * as React from 'react'

import {themeable, omitProps} from '@base/react-utils'

import baseTheme from './PopoverBalloon.css'

@themeable(baseTheme)
class PopoverBalloon extends React.Component {
  static propTypes = {
    onClick: PropTypes.func,

    size: PropTypes.oneOf(['xs', 's', 'm', 'l', 'xl']),
    color: PropTypes.oneOf(['standard', 'danger', 'info', 'tooltip']),
    placement: PropTypes.oneOf(['top', 'left', 'bottom', 'right', 'cover']),
    padded: PropTypes.bool,
    className: PropTypes.string,

    /** Anchor offset in pixels (number) or percent (50%). Be aware, that anchor does not behave well at extreme edges */
    anchor: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

    theme: PropTypes.object,
  }

  static defaultProps = {
    size: 'm',
    color: 'standard',
    placement: 'cover',
    anchor: '50%',
  }

  getClassName() {
    const theme = this.theme

    return classNames([
      theme.Popover,
      theme['size_' + this.props.size] || theme.size_m,
      theme['color_' + this.props.color],
      theme['placement_' + this.props.placement],
      this.props.padded && theme.padded,
      this.props.className,
    ])
  }

  getStyle() {
    return {
      transformOrigin: this.transformOrigin,
      ...(this.props.style || {}),
    }
  }

  getArrowStyle() {
    return {
      [this.isHorizontal ? 'top' : 'left']: this.props.anchor,
    }
  }

  getBalloonStyle() {
    const style = this.props.style || {}
    return {
      maxWidth: style.maxWidth,
      maxHeight: style.maxHeight,
      minWidth: style.minWidth,
      minHeight: style.minHeight,
    }
  }

  get isHorizontal() {
    return this.props.placement === 'left' || this.props.placement === 'right'
  }

  get transformOrigin() {
    let anchor = this.props.anchor
    if (typeof anchor === 'number') anchor += 'px'
    switch (this.props.placement) {
      case 'top':
        return `${anchor} 100%`
      default:
      case 'bottom':
        return `${anchor} 0%`
      case 'left':
        return `100% ${anchor}`
      case 'right':
        return `0% ${anchor}`
    }
  }

  render() {
    const theme = this.theme
    const arrowStyle = {
      ...this.getArrowStyle(),
      display: this.props.placement === 'cover' ? 'none' : 'block',
    }
    return (
      <div
        {...omitProps(this.props, [
          PopoverBalloon.propTypes,
          'tabIndex',
          'autoFocus',
        ])}
        className={this.getClassName()}
        style={this.getStyle()}
      >
        <div
          className={theme.balloon}
          style={this.getBalloonStyle()}
          tabIndex={this.props.tabIndex}
          autoFocus={this.props.autoFocus}
        >
          {this.props.children}
        </div>
        <div className={theme.arrowBorder} style={arrowStyle} />
        <div className={theme.arrow} style={arrowStyle} />
      </div>
    )
  }
}

export default PopoverBalloon

export class PaddedPopoverBalloon extends PopoverBalloon {
  static defaultProps = {
    ...PopoverBalloon.defaultProps,
    padded: true,
  }
}
